import { InputCheck } from '@abb-procure/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormControl, FormRecord, ReactiveFormsModule } from '@angular/forms';
import { FacetResponse } from '../../types/facet-response.type';

@Component({
  selector: 'procure-search-facet',
  templateUrl: './search-facet.component.html',
  styleUrl: './search-facet.component.scss',
  imports: [InputCheck, ReactiveFormsModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchFacet {
  readonly facet = input.required<FacetResponse>();
  readonly control = input.required<FormRecord<FormControl>>();
}
